//Core
import React, {FC} from 'react';
import {Routes} from "./routes";

//Layout
//Styled
import {BodyContainer} from "./components/styled"
import {Snack} from "../snack";

import {SnackbarProvider} from "notistack";
import {Box, ThemeProvider} from "@mui/material";
import {useMainTranslationHookInit} from "../../../newShared/hooks/useMainTranslationHooks/useInit";
import {FlexStart} from '../../../newShared/components/Layouts';
import {useSideBar} from "./hooks/useSideBar";
import {TopBar} from "../topBar";
import colors from "../../../newShared/theme/colors";
import {MessageDialog} from "../MessageDialog";


export const Shell: FC = () => {
    const isHiddenBar = useSideBar();
    const {revDir, themeWithLocale} = useMainTranslationHookInit();

    //when workspace or organization is not selected - disabling  buttons and paths user can't go without selection
    // const {isLoadingCookieData, isWorkspaceSelected, isSignedIn} = useWorkspacesAndOrganizations();

    return (
        <ThemeProvider theme={themeWithLocale}>
            <SnackbarProvider anchorOrigin={{ vertical: 'bottom', horizontal: !revDir ? 'right' : 'left' }} preventDuplicate>
                <FlexStart w={"100vw"} h={"100vh"} of={"hidden"} d={'column'}>
                    <TopBar isHidden={isHiddenBar}/>
                    <BodyContainer w={'100%'}>
                        <Snack/>
                        {/*{isSignedIn && <LeftMenu/>}*/}
                        <Box overflow={"hidden"} height={'100%'} width={'100%'} bgcolor={colors.backgrounds.white}>
                            {/*{!isLoadingCookieData ? <Routes/> : <Spinner />}*/}
                            {<Routes/>}
                            {/*{(isWorkspaceSelected) && <SubscriptionHandler />}*/}
                            {/*<WorkspaceNotSelectedDialog />*/}
                            <MessageDialog/>
                            {/*<DocViewerDialog/>*/}
                            {/*<SelectWorkspaceDialog />*/}
                        </Box>
                    </BodyContainer>
                </FlexStart>
            </SnackbarProvider>

        </ThemeProvider>
    )
}
